import dayjs from 'dayjs';

// Router history can contain a Dayjs instance, its serialized shape, or a string.
export const parseAuditDate = (value) => {
  if (value == null || value === '') return null;
  const parsed = dayjs(value?.$d ?? value);
  return parsed.isValid() ? parsed : null;
};

export const matchesAuditEventType = (actual, expected) =>
  String(actual ?? '').trim().toLowerCase() === String(expected ?? '').trim().toLowerCase();

export const selectAuditSummary = (data, eventType) => {
  const summary = Array.isArray(data) ? data : [];
  return eventType ? summary.filter((item) => matchesAuditEventType(item.Type, eventType)) : summary;
};
